module.exports = __webpack_public_path__ + "static/media/device-right-sidebar.082fb1a6.png";